import React from 'react'
// import Topnavbar from '../header/Topnavbar';
import Footer from '../footer/Footer';
import Topnavbardata from '../header/Topnavbar1';

const TermsandCondition = () => {
  return (
    <div>
        {/* <Topnavbar/> */}
        <Topnavbardata/>
      <section className="dark-background header-section text-center" style={{marginBottom:'-60px'}}>
        <h1 className="mt-xl-5">Terms &amp; Conditions</h1>
        <p>Effective Date: <strong>January 1, 2025</strong></p>
    </section>
    <section className="container">
        <div className="row">
            <div className="col-lg-10 mx-auto">
                <h5>1. Introduction</h5>
                <p>Welcome to <strong>TechBiz SoftwareSolutions</strong>. By using our website (<a href="https://techbizsoftwaresolutions.com/" target="_blank" rel="noreferrer">techbizsoftwaresolutions.com</a>) and services, you agree to these Terms &amp; Conditions.</p>

                <h5>2. Use of Services</h5>
                <ul>
                    <li>Unauthorized access, modification, or misuse of our website is strictly prohibited.</li>
                    <li>We reserve the right to suspend or terminate accounts that violate our policies.</li>
                </ul>

                <h5>3. Intellectual Property</h5>
                <p>All content, trademarks, and software on this website are the property of <strong>TechBiz SoftwareSolutions</strong>. You may not copy, distribute, or modify our content without prior permission.</p>

                <h5>4. Payments &amp; Refunds</h5>
                <ul>
                    <li>All payments must be made in accordance with the agreed terms.</li>
                    <li>Failure to pay may result in service suspension or termination.</li>
                    <li>Refunds are only available under specific conditions outlined in our policies.</li>
                </ul>

                <h5>5. Privacy &amp; Data Protection</h5>
                <p>Your data is protected in accordance with our <a href="privacy-policy" className="text-primary">Privacy Policy</a>. We take reasonable steps to ensure data security and confidentiality.</p>

                <h5>6. Third-Party Links</h5>
                <p>Our website may contain links to third-party websites. We are not responsible for their content or privacy policies.</p>

                <h5>7. Limitation of Liability</h5>
                <p><strong>TechBiz SoftwareSolutions</strong> is not liable for any indirect, incidental, or consequential damages resulting from the use of our services.</p>

                <h5>8. Termination of Services</h5>
                <p>We reserve the right to terminate services for any user who violates these Terms &amp; Conditions.</p>

                <h5>9. Governing Law</h5>
                <p>These terms shall be governed by the laws of <strong>India</strong>. Any disputes shall be resolved through arbitration or legal action as applicable.</p>

                <h5>10. Changes to Terms</h5>
                <p>We may update these terms from time to time. Continued use of our services implies acceptance of the latest terms.</p>

                <h5>11. Contact Information</h5>
                <p>If you have any questions, feel free to contact us:</p>
                <ul>
                    <li>Email: <a href="mailto:support@techbizsoftwaresolutions.com">support@techbizsoftwaresolutions.com</a></li>
                    <li>Phone: +91 84335 53300 / +91 81040 43108</li>
                    <li>Address: Airoli, Navi Mumbai,Maharashtra- 400708, India</li>
                </ul>
            </div>
        </div>
    </section>
     <Footer/>
    </div>
  )
}

export default TermsandCondition;
